const MEDICAL_PROFILE_METADATA_KEYS = new Set([
  'id',
  'referenceid',
  'clientid',
  'clientreferenceid',
  'pregnancyreferenceid',
  'organizationreferenceid',
  'createdon',
  'createdat',
  'createdby',
  'updatedat',
  'updatedby',
  'modifiedat',
  'modifiedby',
  'deletedat',
  'deletedby',
  'isdeleted',
  'rowversion',
  'success',
]);

const ARRAY_MEDICAL_PROFILE_SECTIONS = new Set([
  'conditions',
  'surgeries',
  'familyHistory',
  'outcomes',
  'medications',
]);

function hasMeaningfulMedicalProfileSectionData(key, value) {
  if (ARRAY_MEDICAL_PROFILE_SECTIONS.has(key)) {
    return Array.isArray(value) && value.length > 0;
  }

  return hasMeaningfulMedicalProfileData(value);
}

export function hasMeaningfulMedicalProfileData(value) {
  if (value == null) return false;
  if (typeof value === 'boolean') return value === true;
  if (typeof value === 'number') return !Number.isNaN(value) && value !== 0;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return false;
    if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
      try {
        return hasMeaningfulMedicalProfileData(JSON.parse(trimmed));
      } catch {
        return true;
      }
    }
    return true;
  }
  if (Array.isArray(value)) return value.some(hasMeaningfulMedicalProfileData);
  if (typeof value === 'object') {
    return Object.entries(value).some(([key, nestedValue]) => (
      !MEDICAL_PROFILE_METADATA_KEYS.has(key.toLowerCase())
      && hasMeaningfulMedicalProfileData(nestedValue)
    ));
  }
  return false;
}

export function deriveStructuredMedicalProfileStatus(profileData = {}) {
  const sectionStatus = Object.fromEntries(
    Object.entries(profileData).map(([key, value]) => [key, hasMeaningfulMedicalProfileSectionData(key, value)])
  );
  const hasMedicalHistory = Object.values(sectionStatus).some(Boolean);

  return {
    hasMedicalHistory,
    isComplete: false,
    completionSource: null,
    sectionStatus,
  };
}
